import React, { Component } from 'react';
import logo from './images/logo.svg';
import './App.css';
import './Footer.css';
import { Link } from 'react-router-dom'

class Header extends Component {
  render() {
    return (
      <div id="footer">
        <div className="container">
            <ul>
                <li>Copyright © 2017 Zygous Labs.</li>
                <li><Link to='/contact'>Contact Us</Link></li>
            </ul>
        </div>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Footer.js